import { render, staticRenderFns } from "./FeedbackInTemplate.vue?vue&type=template&id=ff51f1a0&scoped=true&"
import script from "./FeedbackInTemplate.vue?vue&type=script&lang=js&"
export * from "./FeedbackInTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackInTemplate.vue?vue&type=style&index=0&id=ff51f1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff51f1a0",
  null
  
)

export default component.exports